import {DashboardMenuContainer} from "../Dashboard/DashboardMenu";
import {useEffect, useState} from "react";
import {collection, getDocs} from "firebase/firestore";
import {Firestore} from "../../../utils/Firebase";
import Box from "@mui/material/Box";
import Loader from "../../common/Loader/Loader";
import * as React from "react";
import {Button, ButtonBase, Container, Grid, Paper, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {styled} from "@mui/material/styles";

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});

const helpCategories = {
    clothing: 'Oblečenie',
    food: 'Jedlo',
    cosmetic: 'Drogéria',
    other: 'Ostatné'
};

export default function MaterialHelps() {
    const [mhData, setMhData] = useState([])

    useEffect(() => {
        getDocs(collection(Firestore, "materialHelp"))
            .then(d => {
                const array = [];
                d.forEach(doc => {
                    array.push({...doc.data(), id: doc.id});
                });
                setMhData(array);
            })
            .catch(e => {
                console.error(e);
            });
    }, []);

    return( mhData.length === 0
        ? DashboardMenuContainer(<Box justifyContent={"center"} alignItems={"center"}><Loader/></Box>)
        : DashboardMenuContainer(

            <Container maxWidth="lg">
                <h1>Materiálna pomoc</h1>
                <Grid container spacing={2}>
                    {
                        mhData.map(el => {
                            return(
                                <Grid item xs={12}>
                                    <Paper className={"jobs-padding"} sx={{ p: 2, margin: 'auto', maxWidth: 1200, flexGrow: 1 }} key={el.id}>
                                        <Grid container spacing={2}>
                                            <Grid item>
                                                <ButtonBase sx={{ width: 128, height: 100 }}>
                                                    <Img alt="complex" src={el.logo} />
                                                </ButtonBase>
                                            </Grid>
                                            <Grid  className={"jobs-item-center"} item xs>
                                                <div className={"jobs-item-padding"} >
                                                    <Typography gutterBottom variant="subtitle1" component="div">
                                                        {el.provides}
                                                    </Typography>
                                                    <Typography variant="body2" gutterBottom>
                                                        {helpCategories[el.category]}
                                                    </Typography>

                                                </div>
                                            </Grid>
                                            <Grid className={"jobs-item-center"} item key={el.id}>
                                                <Button LinkComponent={Link} to={`/material-help/${el.id}`}>Uprav</Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            )
                        })
                    }
                    <Grid item>
                        <Grid container className={"add-job-button"}>
                            <Button variant="contained" component={Link} to={"/material-help/new"}>Pridať materiálnu pomoc</Button>
                        </Grid>
                    </Grid>
                    </Grid>
            </Container>
        ))
}
